module.exports = __webpack_public_path__ + "img/infrustructure.c4aec53.svg";